export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70eed613162f3f8f21443b5bbc715971ecf32ca196&name=pushAdClickData!'